import {
  LayoutDashboard, Building2, Target, ClipboardList, Users, CalendarClock,
  TrendingUp, FolderKanban, ListChecks, CheckSquare, UsersRound, Clock,
  Receipt, FilePlus2, BarChart3, FolderTree, Settings, Plug, UserCog, FolderLock,
} from "lucide-react";

export const navGroups = [
  {
    label: null,
    items: [{ name: "Dashbord", page: "Dashboard", icon: LayoutDashboard }],
  },
  {
    label: "Salg & vekst",
    items: [
      { name: "Kunder", page: "BusinessCustomers", icon: Building2 },
      {
        name: "Oppkjøpskandidater", page: "AcquisitionCandidates", icon: Target,
        children: [{ name: "Scorecard-maler", page: "ScorecardTemplates", icon: ClipboardList }],
      },
      {
        name: "Investorer", page: "Investors", icon: Users,
        children: [
          { name: "Oppfølginger", page: "FollowUps", icon: CalendarClock },
          { name: "Investeringsanalyse", page: "InvestmentAnalytics", icon: TrendingUp },
        ],
      },
      { name: "Datarom", page: "Deals", icon: FolderLock, externalOk: true },
    ],
  },
  {
    label: "Leveranse",
    items: [
      { name: "Prosjekter", page: "Projects", icon: FolderKanban },
      {
        name: "Oppgaver", page: "Tasks", icon: ListChecks,
        children: [{ name: "Mine oppgaver", page: "MyTasks", icon: CheckSquare }],
      },
      { name: "Ressursstyring", page: "ResourceManagement", icon: UsersRound },
      { name: "Tidsregistrering", page: "TimeTracking", icon: Clock },
    ],
  },
  {
    label: "Økonomi",
    items: [
      {
        name: "Faktura", page: "Invoices", icon: Receipt,
        children: [{ name: "Opprett faktura", page: "CreateInvoice", icon: FilePlus2 }],
      },
      {
        name: "Rapporter", page: "Reports", icon: BarChart3,
        children: [{ name: "Interne prosjekter", page: "InternalProjects", icon: FolderTree }],
      },
    ],
  },
  {
    label: "System",
    items: [
      {
        name: "Innstillinger", page: "UserSettings", icon: Settings,
        children: [{ name: "Integrasjoner", page: "Integrations", icon: Plug }],
      },
      { name: "Brukere", page: "UserManagement", icon: UserCog, adminOnly: true },
    ],
  },
];

export const allNavItems = navGroups.flatMap((g) =>
  g.items.flatMap((i) => [i, ...(i.children || [])])
);

const DETAIL_LABELS = {
  ProjectDetail: "Prosjektdetaljer",
  TaskDetail: "Oppgavedetaljer",
  TeamDetail: "Teamdetaljer",
  Teams: "Team",
  InvestorDetail: "Investordetaljer",
  AcquisitionCandidateDetail: "Kandidatdetaljer",
  ImportData: "Importer data",
  OAuthConsent: "Tilkobling",
  Deals: "Datarom",
  DataRoom: "Datarom",
};

export function pageLabel(pageName) {
  const item = allNavItems.find((i) => i.page === pageName);
  if (item) return item.name;
  if (DETAIL_LABELS[pageName]) return DETAIL_LABELS[pageName];
  return pageName ? pageName.replace(/([A-Z])/g, " $1").trim() : "";
}
